import { render, staticRenderFns } from "./UjianForm.vue?vue&type=template&id=4b0e55d9&scoped=true"
import script from "./UjianForm.vue?vue&type=script&lang=js"
export * from "./UjianForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b0e55d9",
  null
  
)

export default component.exports